// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconHeartPath = 'M5.073 4.003c-.785 0-1.57.295-2.167.89a3.03 3.03 0 0 0 0 4.301l7.087 6.82 7.11-6.835a3.029 3.029 0 0 0-.01-4.293 3.084 3.084 0 0 0-4.334 0L9.992 7.635 7.238 4.892a3.062 3.062 0 0 0-2.165-.888Zm4.919 14.791-8.498-8.176a5.024 5.024 0 0 1-.011-7.139 5.108 5.108 0 0 1 7.179 0l1.332 1.327 1.342-1.332a5.106 5.106 0 0 1 7.179 0 5.021 5.021 0 0 1 0 7.128l-8.523 8.192Z';
var IconHeart = baseIcon('IconHeart', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconHeartPath
});
export default IconHeart;
//# sourceMappingURL=index.js.map